import React from "react";
import Login from "../components/Auth/Login";

function LoginPage() {
  return (
    <div>
      <Login />
    </div>
  );
}

export default LoginPage;
